/* eslint-disable react/prop-types */
import React from "react";

const RouterNotFound = () => {
  return <div>403 not this url</div>;
};
export default RouterNotFound;
